import React from 'react';
import { useTranslation } from 'react-i18next';

const SettingCard = ({ setting, onEdit }) => {
  const { t } = useTranslation();

  if (!setting) {
    return null;
  }

  const renderValue = () => {
    switch (setting.type) {
      case 'toggle':
        return (
          <div className="flex items-center">
            <div className={`w-12 h-6 rounded-full p-1 transition-colors duration-200 ${
              setting.value ? 'bg-[#E8FC8B]' : 'bg-gray-600'
            }`}>
              <div className={`w-4 h-4 rounded-full bg-white transition-transform duration-200 ${
                setting.value ? 'translate-x-6' : 'translate-x-0'
              }`} />
            </div>
            <span className="ml-3 text-[#ABCDDF]">
              {setting.value ? 'Enabled' : 'Disabled'}
            </span>
          </div>
        );
      case 'select':
        return (
          <span className="text-[#E8FC8B] font-medium">{setting.value}</span>
        );
      case 'number':
        return (
          <span className="text-[#E8FC8B] font-medium">{setting.value}</span>
        );
      default:
        return (
          <span className="text-[#E8FC8B] font-medium">{setting.value}</span>
        );
    }
  };

  return (
    <div className="bg-[#2A3C29] p-6 rounded-lg hover:bg-[#3A4C39] transition-colors duration-200">
      <div className="flex justify-between items-start mb-4">
        <div className="flex-1">
          <h3 className="text-lg font-semibold text-[#E8FC8B] mb-1">
            {setting.title}
          </h3>
          <p className="text-sm text-[#ABCDDF] mb-3">
            {setting.description}
          </p>
        </div>
        <button
          onClick={onEdit}
          className="ml-4 text-blue-400 hover:text-blue-300 text-sm font-medium"
        >
          {t('edit')}
        </button>
      </div>
      
      <div className="flex items-center justify-between">
        <span className="text-sm text-[#ABCDDF] font-medium">Current Value:</span>
        {renderValue()}
      </div>
    </div>
  );
};

export default SettingCard; 